import { render, staticRenderFns } from "./RegisterCredentialPuntosColombia.vue?vue&type=template&id=13625852"
import script from "./RegisterCredentialPuntosColombia.vue?vue&type=script&lang=js"
export * from "./RegisterCredentialPuntosColombia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13625852')) {
      api.createRecord('13625852', component.options)
    } else {
      api.reload('13625852', component.options)
    }
    module.hot.accept("./RegisterCredentialPuntosColombia.vue?vue&type=template&id=13625852", function () {
      api.rerender('13625852', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/administration/components/LoyaltyConfig/components/RegisterCredentialPuntosColombia.vue"
export default component.exports